<template>
  <v-row>
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="90%"
        :retain-focus="false"
        fullscreen
      >
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-toolbar dark color="primary">
              <v-toolbar-title
                >COD Details
                <div style="font-size: 13px;">
                  {{ selectedData ? selectedData.name : "" }}
                </div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="cancel">
                  Close
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-tabs vertical>
                <v-tab
                  v-for="(tab, i) in tabs"
                  :key="i"
                  @click="loadCompent(tab, i)"
                >
                  {{ tab.name }}
                </v-tab>

                <v-tab-item v-for="(tab, k) in tabs" :key="k">
                  <v-card flat>
                    <v-card-text>
                      <component
                        :is="tab.component"
                        :distributorId="selectedData.distributorId"
                        :isDistributor="true"
                        :key="`${tab.key}_${tab.count}_${componentKey}`"
                      ></component>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
import OnlineForConfirmation from "../../acquisition/OnlineForConfirmation.vue";
import OnlineForInstallation from "../../acquisition/OnlineForInstallation.vue";
import OnlineForInstallationPaid from "../../acquisition/OnlineForInstallationPaid.vue";
import OnlinePastDue from "../../acquisition/OnlinePastDue.vue";
import OnlineInstalled from "../../acquisition/OnlineInstalled.vue";
import OnlineCancelled from "../../acquisition/OnlineCancelled.vue";

export default {
  mixins: [ShareableMethods],
  name: "DistributorCod",
  components: {
    OnlineForConfirmation,
    OnlineForInstallation,
    OnlineForInstallationPaid,
    OnlinePastDue,
    OnlineInstalled,
    OnlineCancelled,
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      search: "",
      selectedData: {
        distributorId: "",
      },

      componentKey: Math.random(),

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      tabs: [
        {
          name: "For Confirmation",
          key: "FOR_CONFIRMATION",
          count: 1,
          component: OnlineForConfirmation,
        },
        {
          name: "For Installation (COD)",
          key: "INSTALLATION_COD",
          count: 1,
          component: OnlineForInstallation,
        },
        {
          name: "For Installation (PAID)",
          key: "INSTALLATION_PAID",
          count: 1,
          component: OnlineForInstallationPaid,
        },
        {
          name: "Past Due",
          key: "PAST_DUE",
          count: 1,
          component: OnlinePastDue,
        },
        {
          name: "Installed",
          key: "INSTALLED",
          count: 1,
          component: OnlineInstalled,
        },
        {
          name: "Cancelled",
          key: "CANCELLED",
          count: 1,
          component: OnlineCancelled,
        },
      ],
    };
  },

  methods: {
    open(data) {
      this.dialog = true;
      this.selectedData = data;

      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    loadCompent(item, i) {
      console.log(item)
      this.tabs[i].count += 1;
    },

    agree() {
      this.resolve(true);
      this.componentKey = Math.random();
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.componentKey = Math.random();
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}

.v-tab {
  display: flex;
  justify-content: flex-start;
}
</style>
